import styled from "styled-components";

export default function TodolistGroupBlock({ children }) {
  return <Block>{children}</Block>;
}

const Block = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: calc(100vw * (6.5 / 375));
  padding-bottom: calc(100vw * (6.5 / 375));
`;
